import React from 'react';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

/**
 * Service fee line item.
 *
 * The fee is still computed server-side and included in the renter's total,
 * but we no longer surface it as its own row in the breakdown — the rental
 * line already reads as an all-in price and the FAQ explains what's
 * included. Keeping the component as a no-op so the server-side line item
 * can stay in place without UI churn.
 */
const LineItemServiceFeeMaybe = () => null;

export default LineItemServiceFeeMaybe;
